export default '0.9.0';



// WEBPACK FOOTER //
// ./version.js